module.exports = __webpack_public_path__ + "img/Gurnoor1.537b98ef.jpg";